export const DashboardPage = () => {
    return (
        <>
            <h1>Welcome to Pomegranate Admin!</h1>
            <p>Stay awhile and listen</p>
        </>
    )
}
